import React, { Component } from 'react';
import history from './History';

class Logout extends Component {
  render() {
    fetch('https://delta.megadigm.com:2191/session/logout', {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/text'
      }
    }).then(res => {
      if (res.ok && !(document.cookie)) {
        this.props.setLoggedInFlag();
        // send user to home page after successful logout:
        history.push("/");
        return "success";
      } else {
        return res.json();
      }        
    }).then(data => {
      // console.log("Response: " + data);
    }).catch((error) => {
      // console.log(error);
    });

    return (
      <div />
    );
  }
}

export default Logout;